import axiosPrivate from "../axiosPrivate";
import { GET_PATIENT_URL } from "src/constants";

export const getPatient = (searchFilters) => {
  return axiosPrivate.get(GET_PATIENT_URL, { params: searchFilters });
};
